import type { ApiResponse, MindMapNode, MindMapEdge } from '@bandos/shared'
import { HttpClient } from '../../../../services/api/client'
import { getAuthenticatedHeaders } from '../../../../services/ai/aiHelpers'

interface NodeChatHistoryMessage {
  role: 'user' | 'ai'
  content: string
}

export interface NodeChatResponse {
  response: string
  /** suggest_edit tool calls only — generate_suggestions is now executed server-side */
  toolCalls?: { name: string; args: Record<string, string> }[]
  /** Server-side generation results (from generate_suggestions tool execution) */
  generatedSuggestions?: {
    nodes: MindMapNode[]
    edges: MindMapEdge[]
    suggestionIds: string[]
    batchId: number
    feedback?: string
  }
}

export async function sendNodeChatMessage(
  mindmapId: string,
  nodeId: string,
  message: string,
  history: NodeChatHistoryMessage[],
  sidebarFeedbackHistory?: string[],
  autoGenerate?: boolean
): Promise<ApiResponse<NodeChatResponse>> {
  const auth = await getAuthenticatedHeaders<NodeChatResponse>()
  if (auth.error) return auth.error

  return HttpClient.post<NodeChatResponse>(
    '/ai/node-chat',
    {
      mindmapId,
      nodeId,
      message,
      history,
      ...(sidebarFeedbackHistory && sidebarFeedbackHistory.length > 0
        ? { sidebarFeedbackHistory }
        : {}),
      ...(autoGenerate ? { autoGenerate: true } : {}),
    },
    auth.headers
  )
}
